import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, HStack, VStack } from "native-base";
import { formatDate } from "@madmedical/utils";
import { useCallback } from "react";
import { useTranslation } from "@madmedical/i18n";
import useResponsive from "../../../util/useResponsive";
import { useCurrentPatient } from "../../../providers/currentPatient";
import FormControl from "../../../form/FormControl";
import FormDisplay from "../../../molecules/Form/FormControl";
import PreOpWrapper from "./PreOpWrapper";
const Welcome = ({ onPreviousPress, onNextPress }) => {
    const { patient } = useCurrentPatient();
    const { isSmallScreen } = useResponsive();
    const { t } = useTranslation();
    const validate = useCallback((values) => {
        var _a, _b, _c;
        const bodyWeightKg = parseInt((_a = values.bodyWeightKg) !== null && _a !== void 0 ? _a : "0");
        const bodyHeightCm = parseInt((_b = values.bodyHeightCm) !== null && _b !== void 0 ? _b : "0");
        const operation = (_c = values.operation) !== null && _c !== void 0 ? _c : "";
        return (bodyWeightKg > 1 &&
            bodyWeightKg < 500 &&
            bodyHeightCm > 30 &&
            bodyHeightCm < 250 &&
            operation.length > 3);
    }, []);
    return (_jsx(PreOpWrapper, Object.assign({ onPreviousPress: onPreviousPress, onNextPress: onNextPress, validate: validate }, { children: _jsxs(VStack, Object.assign({ space: 6, flex: 1, width: {
                base: "full",
                md: "1/2",
            }, p: {
                base: 4,
                md: 6,
            } }, { children: [_jsx(HStack, Object.assign({ space: 3 }, { children: _jsx(FormDisplay, { value: patient.fullName, label: t("name"), isReadOnly: true, size: "md" }) })), _jsx(Box, Object.assign({ width: "full" }, { children: _jsx(FormDisplay, { value: patient.birthDate
                            ? formatDate(patient.birthDate)
                            : "–", label: t("dateOfBirth"), isReadOnly: true, size: "md" }) })), _jsxs(HStack, Object.assign({ space: 3, direction: isSmallScreen ? "column" : "row" }, { children: [_jsx(FormControl, { name: "bodyWeightKg", type: "number", label: t("measures:bodyWeight"), suffix: _jsx(Box, Object.assign({ px: 3 }, { children: "kg" })), size: "md", isRequired: true }), _jsx(FormControl, { name: "bodyHeightCm", type: "number", label: t("height"), suffix: _jsx(Box, Object.assign({ px: 3 }, { children: "cm" })), size: "md", isRequired: true })] })), _jsx(Box, { children: _jsx(FormControl, { name: "operation", label: t("plannedSurgery"), size: "md", isRequired: true }) })] })) })));
};
export default Welcome;
